import { MetaAdReferral } from 'data/firestore/globals';

const isMetaAdReferral = (value: unknown): value is MetaAdReferral => {
    if (!value || typeof value !== 'object') return false;
    const { channel } = value as { channel?: unknown };
    return channel === 'whatsapp' || channel === 'facebook' || channel === 'instagram';
};

const readMessageAdReferral = (message: { metadata?: object }): MetaAdReferral | undefined => {
    const metadata = message.metadata as { metaAdReferral?: unknown } | undefined;
    const referral = metadata?.metaAdReferral;
    return isMetaAdReferral(referral) ? referral : undefined;
};

export default readMessageAdReferral;
